<!--阅读说明-->
<div id="swipeContainer">
  <!--头部-->
  <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0"></div>
  <!--标题-->
  <div class="reportTitle">
    <p class="courseName">{{courseName}}</p>
    <p class="title">{{pageTitle}}</p>
  </div>
  <!--阅读说明-->
  <div class="surveyCard" *ngIf="surveyStatus == 1">
    <p class="surveyCardTitle textCenter">{{staticDoc.title[3]}}</p>
    <p [innerHtml]="staticDoc.instructions[0]"></p>
    <p [innerHtml]="staticDoc.instructions[1]"></p>
    <p [innerHtml]="staticDoc.instructions[2]"></p>
    <p [innerHtml]="staticDoc.instructions[3]"></p>
  </div>


  <div class="surveyCard" *ngIf="surveyStatus == 2">
    <p class="surveyCardTitle textCenter">{{staticDoc.title[2]}}</p>
    <p [innerHtml]="staticDoc.instructions[0]"></p>
    <p [innerHtml]="staticDoc.instructions[1]"></p>
    <p [innerHtml]="staticDoc.instructions[2]"></p>
    <p [innerHtml]="staticDoc.instructions[3]"></p>
  </div>

  <!--箭头-->
  <div id="bottomSpace">
    <div *ngIf="isPC && showPCBtn" class="pc-btn" (click)="goNext()">查看报告</div>
    <img *ngIf="!isPC" class="topArrow" src="{{assetsRoute}}/picture/reportnew/arrow.png" alt="">
  </div>
</div>

<app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

<!--报告-->
<div class="abilityReport">

  <!--头部-->
  <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0"></div>


  <!--标题-->
  <div class="reportTitle">
    <p class="courseName">{{courseName}}</p>
    <p class="title">{{pageTitle}}</p>
  </div>


  <!--前测-->
  <div class="abilityFrontTest" *ngIf="surveyStatus == 1">
    <!--标题-->
    <div class="reportTitle">
      <p class="courseName">{{courseName}}</p>
      <p class="title">{{pageTitle}}</p>
    </div>
    <!--学前测评-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle">{{staticDoc.title[0]}}</p>
      <!--图表-->
      <div class="lineCharts preTest lineChartsGoodBG">
        <!--后测比前测高图表-->
        <div class="specialAxis clearfix">
          <div class="lv" id="lv1"></div>
          <div class="lv" id="lv2"></div>
          <div class="lv" id="lv3"></div>
          <div class="lv" id="lv4"></div>
          <div class="lv" id="lv5"></div>
          <div class="lv" id="lv6"></div>
        </div>

        <!--前后测倒挂&&前后测等级一样-->
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li><i class="lv1"></i></li>
          <li><i class="lv2"></i></li>
          <li><i class="lv3"></i></li>
          <li><i class="lv4"></i></li>
          <li><i class="lv5"></i></li>
          <li><i class="lv6"></i></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="xAxis clearfix">
          <li>薄弱</li>
          <li>有限</li>
          <li>一般</li>
          <li>良好</li>
          <li>优秀</li>
          <li>卓越</li>
        </ul>
      </div>
      <!--导师评语-->
      <div class="tutorWrap">
        <div class="tutorContent">
          <p>{{levelDesc}}</p>
        </div>
        <div class="teacherPhoto" *ngIf="teacherName">
          <img src="{{assetsRoute}}/picture/abilitysurvey/photo/{{teacherName}}.png" alt="">
        </div>
      </div>

    </div>

    <!--学习建议-->
    <div class="surveyItemCard">
      <div class="suggestHead">
        <div class="surveyItemCardTitle {{teacherName}}">{{staticDoc.title[2]}}</div>
      </div>

      <!--学习建议内容-->
      <div class="suggestContent">
        <div class="suggestDesc">{{suggest}}</div>
        <div class="suggestList" *ngFor="let item of learningTips;let i =index">
          <div class="title">
            <div>
              <span class="iconCircle" *ngIf="item.learningTipsTitle">{{i+1}}</span>
              {{item.learningTipsTitle}}
            </div>
          </div>
          <div class="content">{{item.learningTipsContent}}</div>
        </div>
      </div>
    </div>

    <div class="button">
      <component-button  [theme]="buttonTheme" [isDisabled]="false" (onCommit)="close()"></component-button>
    </div>
    <!--    <div class="bottomBtn" *ngIf="isOpenClass==0" (click)="getCourse()">进入课程学习</div>-->
  </div>

  <!--后测-->
  <div class="abilityAfterTest" *ngIf="surveyStatus == 2">
    <!--对比-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle multiLine">{{contrastSpeech}}</p>
      <!--图表-->
      <div class="lineCharts postTest lineCharts{{contrast}}BG">
        <!--后测比前测高图表-->
        <div class="specialAxis clearfix">
          <div class="lv" id="lv1"></div>
          <div class="lv" id="lv2"></div>
          <div class="lv" id="lv3"></div>
          <div class="lv" id="lv4"></div>
          <div class="lv" id="lv5"></div>
          <div class="lv" id="lv6"></div>
        </div>

        <!--前后测倒挂&&前后测等级一样-->
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li><i class="lv1"></i></li>
          <li><i class="lv2"></i></li>
          <li><i class="lv3"></i></li>
          <li><i class="lv4"></i></li>
          <li><i class="lv5"></i></li>
          <li><i class="lv6"></i></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="xAxis clearfix">
          <li>薄弱</li>
          <li>有限</li>
          <li>一般</li>
          <li>良好</li>
          <li>优秀</li>
          <li>卓越</li>
        </ul>
      </div>
      <!--导师评语-->
      <div class="tutorWrap">
        <div class="tutorContent">
          <p>{{contrastDesc}}</p>
        </div>
        <div class="teacherPhoto" *ngIf="teacherName">
          <img src="{{assetsRoute}}/picture/abilitysurvey/photo/{{teacherName}}.png" alt="">
        </div>
      </div>

    </div>


    <!--发展建议-->
    <div class="surveyItemCard">
      <div class="suggestHead">
        <div class="surveyItemCardTitle {{teacherName}}">{{staticDoc.title[1]}}</div>
      </div>

      <!--发展建议内容-->
      <div class="suggestContent develop" *ngIf="developmentTipsKas&&developmentTipsKas.length!==0">
        <div class="suggestList" *ngFor="let item of developmentTipsKas;let i = index">
          <div class="suggestList-partition" *ngIf="developmentTipsKas.length > 1"></div>
          <div class="serial-number-img" *ngIf="developmentTipsKas.length > 1"></div>
          <div class="serial-number" *ngIf="developmentTipsKas.length > 1">{{i + 1}}</div>
          <div class="content">
            <div class="content-title-develop">{{item.a_kaName}}</div>
            <div class="content-value">{{item.a_suggest}}</div>
            <div class="content-title-develop marginY-16">实用技巧</div>
            <div class="content-group" *ngFor="let child of item.a_skill">
              <div class="dot"></div><div class="content-value">{{child}}</div>
            </div>
            <div class="content-title-skill marginY-16">发展活动</div>
            <div class="content-group" *ngFor="let child of item.a_activ">
              <div class="dot"></div><div class="content-value">{{ child }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--发展建议内容(不存在有待提高的KA)-->
      <div class="suggestContent develop" *ngIf="developmentTipsKas&&developmentTipsKas.length==0">
        <div class="suggestList" *ngFor="let item of developmentTipsFixedSpeech;let i = index">
          <div class="content" [innerHtml]="item"></div>
        </div>
      </div>

    </div>

    <div class="button">
      <component-button  [theme]="buttonTheme" [isDisabled]="false" (onCommit)="close()"></component-button>
    </div>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-leadership-report/camp-leadership-report.component.html